"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabContextProvider = exports.TabContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Props for the Provider.

// Handles props to the context.

const TabContext = exports.TabContext = /*#__PURE__*/_react.default.createContext({
  active: 0,
  width: 0,
  setActive: () => {},
  setWidth: () => {}
});
const TabContextProvider = ({
  children,
  value,
  onChange
}) => {
  const [active, setActive] = (0, _react.useState)(value || 0);
  const [widthObjects, setWidthObjects] = (0, _react.useState)({});
  const [initialized, setInitialized] = (0, _react.useState)(false);
  const width = Object.values(widthObjects).reduce((a, b) => a + b, 0);
  const setWidth = obj => {
    const [[key, value]] = Object.entries(obj);
    setWidthObjects(prev => ({
      ...prev,
      [key]: value
    }));
  };
  const handleChange = (0, _react.useCallback)(() => {
    if (!initialized) {
      setInitialized(true);
      return;
    }
    onChange(active);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);
  (0, _react.useEffect)(() => {
    if (value) setActive(value);
  }, [value]);
  (0, _react.useEffect)(() => {
    handleChange();
  }, [handleChange]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(TabContext.Provider, {
    value: {
      active,
      setActive,
      setWidth,
      width
    },
    children: children
  });
};
exports.TabContextProvider = TabContextProvider;